import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import News from "./pages/News";
import ArticleDetail from "./pages/ArticleDetail";
import Calculator from "./pages/Calculator";
import NeighborhoodGuide from "./pages/NeighborhoodGuide";
import Properties from "./pages/Properties";
import { trackPageView } from "./utils/analytics";

// Component to handle scroll to hash on navigation and track page views
function ScrollToHash() {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on every navigation
    const pageName = location.pathname === '/' ? '/inicio' : location.pathname;
    trackPageView(pageName);
    
    if (location.hash) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Scroll to top when navigating to a page without hash
      window.scrollTo(0, 0);
    }
  }, [location]);
  
  return null;
}

function App() {
  // Warmup: fire-and-forget ping to wake up backend + DB on first paint
  useEffect(() => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    if (!API_URL) return;
    fetch(`${API_URL}/api/`, { method: 'GET', cache: 'no-store' }).catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/noticias" element={<News />} />
          <Route path="/noticias/:id" element={<ArticleDetail />} />
          <Route path="/calculadora" element={<Calculator />} />
          <Route path="/barrios" element={<NeighborhoodGuide />} />
          <Route path="/propiedades" element={<Properties />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;